/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAvailableSlotsResponse } from "../../entities/models/AvailableSlotsResponse";
import { z } from "zod/v4";

export const modelsAvailableSlotsResponseSchema = z.object({
    "barber_id": z.optional(z.int()),
"slots": z.optional(z.array(z.string()))
    }) as unknown as z.ZodType<ModelsAvailableSlotsResponse>